import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmPartnerContract } from "@natiwi/shared/models/partner-contract.model";

export class NatPartnerContractRepository extends NatCatalogRepository<OrmPartnerContract> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/partnerContracts';
        let repoModel: Type<OrmPartnerContract> = OrmPartnerContract;
        this.init(repoUrl, repoModel);
    }
}